/* eslint-disable function-paren-newline */
/* eslint-disable arrow-parens */
/* eslint-disable comma-dangle */
/* eslint-disable no-mixed-operators */
/* eslint-disable quotes */
const mql = window.matchMedia('(min-width: 830px)');

let componentStore = [];

function onMediaQueryChange(mq) {
  componentStore.forEach(
    (component) => component.deconstructor && component.deconstructor()
  );
  componentStore = [];

  document.querySelectorAll('.mindmap').forEach(($el) => {
    const isDesktop = mq.matches;
    const $center = $el.querySelector("[data-position='center']");
    const $items = $el.querySelectorAll('.mindmap__item');

    const $existingSvg = $el.querySelector('svg:not(.icon)');
    if ($existingSvg) {
      $existingSvg.remove();
    }
    const $svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    $svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    $svg.setAttribute('width', '100%');
    $svg.setAttribute('height', '100%');

    $el.insertBefore($svg, $el.firstChild);

    const drawConnector = () => {
      const posCenter = {
        x: $center.offsetLeft + $center.offsetWidth / 2,
        y: $center.offsetTop,
      };
      const preparePath = () => {
        const $path = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'path'
        );
        $path.setAttribute('fill', 'none');
        $path.setAttribute('stroke', '#000');
        $path.setAttribute('stroke-width', '1px');
        $path.setAttribute('shape-rendering', 'crispEdges');
        $path.setAttribute('class', 'connector');
        return $path;
      };
      const lines = {
        top: [],
        bottom: [],
        center: [],
      };

      $items.forEach(($item) => {
        const id = $item.getAttribute('data-position');
        const idNumber = parseInt(id, 10);
        if (id !== 'center' && idNumber <= 10) {
          if (idNumber === 10 || idNumber === 5) {
            const offset =
              idNumber === 5
                ? $item.offsetLeft
                : $item.offsetLeft + $item.offsetWidth;
            const posItem = {
              x: offset,
              y: $item.offsetTop + $item.offsetHeight / 2,
            };
            const straightLine = `M${posItem.x},${posItem.y} h ${
              posCenter.x - posItem.x
            }`;
            lines.center.push(straightLine);
          } else if (idNumber >= 6) {
            const posItem = {
              x: $item.offsetLeft + $item.offsetWidth / 2,
              y: $item.offsetTop,
            };
            const lineFromBottom = `M${posItem.x},${posItem.y} v -20 h ${
              posCenter.x - posItem.x
            } v -20`;
            lines.bottom.push(lineFromBottom);
          } else {
            const posItem = {
              x: $item.offsetLeft + $item.offsetWidth / 2,
              y: $item.offsetTop + $item.offsetHeight,
            };
            const lineFromTop = `M${posItem.x},${posItem.y} v 20 h ${
              posCenter.x - posItem.x
            } v 20`;
            lines.top.push(lineFromTop);
          }
        }
      });

      const linesTop = lines.top.join(' ');
      const linesBottom = lines.bottom.join(' ');
      const linesCenter = lines.center.join(' ');

      const $existingPath = $svg.querySelector('.connector');
      if ($existingPath) {
        $existingPath.remove();
      }
      const $connector = preparePath();
      $connector.setAttribute('d', `${linesTop} ${linesBottom} ${linesCenter}`);
      $svg.appendChild($connector, $svg);
    };

    const destroyConnector = () => {
      window.removeEventListener('resize', drawConnector);
      $svg.remove();
    };

    if (!isDesktop) {
      destroyConnector();
      return;
    }

    if ($items.length <= 11) {
      window.addEventListener('resize', drawConnector);
      drawConnector();
    }
  });
}

mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
